// Semáforos de una unidad, compartidos por la tarjeta (VehicleCard) y la fila
// compacta (VehicleRow). Antes vivían sólo en VehicleCard; al sumar los mismos
// indicadores a la fila, dos copias de los umbrales iban a divergir.
// Los umbrales son los que ya usaba la tarjeta, sin cambios.

export type Tone = "green" | "yellow" | "red" | "gray";

export const TONE_COLOR: Record<Tone, string> = {
  green: "#22C55E",
  yellow: "#F59E0B",
  red: "#EF4444",
  gray: "#9CA3AF",
};

export const TONE_BORDER: Record<Tone, string> = {
  green: "border-[#22C55E]",
  yellow: "border-[#F59E0B]",
  red: "border-[#EF4444]",
  gray: "border-gray-500",
};

// Batería en %: >80 verde, >60 amarillo, resto rojo. 0 o sin dato = gris,
// como ya lo trataba la tarjeta (no se verificó si un 0 es batería muerta o
// un equipo que no reporta el campo; por eso no se pinta rojo).
export const batteryTone = (battery: number | null | undefined): Tone => {
  if (battery == null || battery === 0) return "gray";
  if (battery > 80) return "green";
  if (battery > 60) return "yellow";
  return "red";
};

// GPS: sólo avisa cuando no hay fijo (0 satélites). Con señal, o sin el
// campo, queda neutro: un verde permanente sería ruido.
export const gpsTone = (gpsSat: number | null | undefined): Tone =>
  gpsSat === 0 ? "red" : "gray";

// Último reporte (epoch en segundos): <30 min verde, <60 min amarillo; más
// viejo, gris — a los 60 min el store ya la cuenta como "Sin Datos".
export const connectionTone = (seconds: number | null | undefined, nowMs: number): Tone => {
  if (!seconds) return "gray";
  const minutes = Math.floor((nowMs - seconds * 1000) / 60000);
  if (minutes < 30) return "green";
  if (minutes < 60) return "yellow";
  return "gray";
};

// Odómetro: no tiene un "bien" o "mal" propio (no hay intervalos de servicio
// en los datos), así que el semáforo sólo dice si el equipo lo está
// reportando: verde con dato, gris sin él. El valor va en el tooltip.
export const odometerTone = (km: number | null | undefined): Tone =>
  km != null && km > 0 ? "green" : "gray";

// Calificación de conducción (A-G, la de «Comportamiento del conductor»):
// A-B verde, C-D amarillo, E-G rojo, como el semáforo de Mapon en su tarjeta.
// Sin manejo en el día («—») queda gris.
export const gradeTone = (grade: string): Tone => {
  if (grade === "A" || grade === "B") return "green";
  if (grade === "C" || grade === "D") return "yellow";
  if (grade === "E" || grade === "F" || grade === "G") return "red";
  return "gray";
};
